import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const useTaxes = (params, options = {}) => {
  return useQuery(
    ["taxesReport", params],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.getTaxes(), {
        params,
      });
      const composeResponse = {
        clinics: res.data.data.clinics,
        reportData: res.data.data.report_data,
        total: res.data.data.total,
        salesHeader: res.data.data.sales_header,
      };
      return composeResponse;
    },
    options,
  );
};
